export default __webpack_public_path__ + "static/media/sangrado_digestivo_origen_oscuro.8769d166.pdf";